export enum ApplicationStatus {
    draft = 'Draft',
    sent = 'Sent',
    inReview = 'InReview',
    incomplete = 'Incomplete',
    inProgress = 'InProgress',
    proposalSent = 'ProposalSent',
    linked = 'Linked',
    operatorDeclarationReceived = 'OperatorDeclarationReceived',
    finishNotificationReceived = 'FinishNotificationReceived',
    operational = 'Operational',
    deleted = 'Deleted',
    rejected = 'Rejected',
}
